import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators, NgForm } from '@angular/forms';
import { AuthenticationService } from './../../_services/authentication.service';
import { first } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ManageuserService } from '../../_services/manageuser-service';
import { LoaderService } from '../../_services/loader.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './reset-password.component.html'
})
export class ResetPasswordComponent implements OnInit {
	resetPasswordForm: FormGroup;
	// loading = false;
	token = '';
	model: any = {};
	isDisplayForm: Boolean = true;
	subscription: Subscription;
	public passwordFieldType: string = 'password';
	public eyeIconClass: string = 'fa fa-eye';

	constructor( private authenticationService: AuthenticationService, 
		private route: ActivatedRoute, 
		private router: Router, 
		private toastr: ToastrService,
		private manageuserService: ManageuserService,
		private loader: LoaderService) {
		this.token = this.route.snapshot.queryParams['t'] || this.route.snapshot.queryParams['token'];
	}

  	ngOnInit() {
			this.model.conf_pass_match = '';
  		this.validateResetPass();
  	}

  	validateResetPass() {
  		this.authenticationService.validateResetPass(this.token)
	      .pipe(first())
	      .subscribe(
	          (data: any) => {
	              	if (data.meta.status) {
						  this.isDisplayForm = true;
						  // this.toastr.success(data.meta.message)
   	         			// this.initForm();
	              	} else {
						this.toastr.error('Something went wrong please try again.');
	              	}
	          },
	          (error: any) => {
			//   this.router.navigate(['login']);
			   this.toastr.error(error.meta.message);
	    });
  	}

  	onSubmit(frm: NgForm) {
  		// stop here if form is invalid
	    if (frm.invalid) {
	        return;
	    }
    	this.loader.showLoader();
  		this.authenticationService.resetPass(this.token, this.model.password, this.model.cpassword)
	      .pipe(first())
	      .subscribe(
	          data => {
				this.loader.hideLoader();
	              	if (data.meta.status) {
							this.router.navigate(['login']);
							this.toastr.success(data.meta.message);
							frm.resetForm();
	              	}
	          },
	          error => {
				this.loader.hideLoader();
	            const errorData = error;
				const self = this;
				if (errorData && errorData.meta) {
					if (errorData.meta.message_code === 'VALIDATION_ERROR') {
						for (const key in errorData.errors) {
							if (key) {
							self.toastr.error(errorData.errors[key][0]);
							}
						}
					} else {
						self.toastr.error(errorData.meta.message);
					}
				} else {
					this.toastr.error('Something went wrong please try again.');
				}
	    });

	  }
	  checkPass() {
			this.model.conf_pass_match = this.manageuserService.checkPassword(this.model.password);
	  }

	  public togglePasswordField(): void {
		this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
		this.eyeIconClass = this.eyeIconClass === 'fa fa-eye' ? 'fa fa-eye-slash' : 'fa fa-eye';
	  }
}
